import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminUsers from "@/pages/admin/AdminUsers";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/users")({
  head: () => adminHead("User Management | Admin", "Manage admin users and roles.", "/admin/users"),
  component: () => (
    <ProtectedRoute>
      <AdminUsers />
    </ProtectedRoute>
  ),
});
